
import React,{ useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Drawer, Col, Row, Divider } from 'antd';
import { DoubleRightOutlined, CloseOutlined  } from '@ant-design/icons';


import Energy1 from '../../../image/Energy1-24x24.svg'
import Strength from '../../../image/Strength-24x24.svg'
import Endurance from '../../../image/Endurance-24x24.svg'
import OptimalLevels from '../../../image/Optimal-Levels-24x24.svg'
import Energy2 from '../../../image/Energy2-24x24.svg'
import Youthfulness from '../../../image/Youthfulness-26x26.svg'
import Resilience from '../../../image/Resilience-24x24.svg'
import GentlePower from '../../../image/Gentle-Power-24x24.svg'

import Energy_Black from '../../../image/Energy1-black-40x40.svg'
import Strength_Black from '../../../image/Strength-black-40x40.svg'
import Endurance_Black from '../../../image/Endurance-black-40x40.svg'
import OptimalLevels_Black from '../../../image/Optimal-levels-black-40x40.svg'

import BigCard from '../../../components/BigCard/BigCard';
import HumanBody from '../../../components/HumanBody/HumanBody';
import CardDom from '../../../components/CardDom/CardDom';
import Menu from '../../../components/Menu/Menu';
import ChartLineDom from '../../../components/ChartLineDom/ChartLineDom';
import PhotoWall from '../../../components/PhotoWall/PhotoWall';

import './science.less'

const Science = () => {
  const navigate = useNavigate();
  const stickyRef = useRef()

  const [winH, setWinH] = useState(0);
  const [distanceToTop, setDistanceToTop] = useState(0);
  
  const [selectMenu, setSelectMenu] = useState('')
  const menuData = [{
    label: '肌肉功能',
    value: '0',
  }]


  const [selectExpert, setSelectExpert] = useState({})
  const [openDrawer, setOpenDrawer] = useState(false);


  
  let imgCardData = {
    type: 'imgCard',
    bgImg: require('../../../image/bigCardBg1-1600x2000.png'),
    textWidth: '40%',
    textPosition: 'left',
    textAlignItem: 'center',
    title: 'Mitopure®, the nutrient that can re‑energize cells',
    titleSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)',
    spacing: 30,
    description: 'As we age, our cells age. Mitopure® is the first postbiotic nutrient shown to trigger a crucial recycling process within our cells called mitophagy, targeting age-related cellular decline*.',
    descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    descriptionColor: 'rgba(0,0,0,0.54)',
    btnConfig:{
      text: 'Learn more',
      link: ''
    }
  }

  let bigCardData = {
    type: 'bgCard',
    bgImg: require('../../../image/bigCardBg-3840x1440.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: '大约90%的细胞能量是由线粒体产生的',
    description: '线粒体是我们细胞的能量来源。构成我们身体组织的数万亿个细胞依靠它们产生的能量运行。',
    btnConfig: null
  }

  let bigCardData1 = {
    type: 'bgCard',
    bgImg: require('../../../image/bigCardBg2-2640x1200.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: '线粒体功能的增强是清除衰老环境的关键。',
    description: '通过线粒体生物发生(mitochondrialbiogenesis)和线粒体自噬(mitophagy)的协同作用，能有效减少活性氧(ROS)堆积，修复细胞能量代谢。这不仅能从源头阻断促炎因子SASP(衰老相关分泌表型)的产生，还能激活免疫细胞对衰老细胞的识别与清除，从而改善组织微环境，延缓机体衰老。',
    btnConfig:false
  }

  let stickyIconList = [{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(90deg)', fontSize: 24}}/>,
      divider: true,
      title: '能源供应不足',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(90deg)', fontSize: 24}}/>,
      divider: true,
      title: '有害分子的产生',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(90deg)', fontSize: 24}}/>,
      divider: true,
      title: '细胞健康降低',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  }]

  let stickyIconList2 = [{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(270deg)', fontSize: 24}}/>,
      divider: true,
      title: '更好的线粒体质量',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(270deg)', fontSize: 24}}/>,
      divider: true,
      title: '改善细胞健康',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(270deg)', fontSize: 24}}/>,
      divider: true,
      title: '增强肌肉力量',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <DoubleRightOutlined style={{transform: 'rotatez(270deg)', fontSize: 24}}/>,
      divider: true,
      title: '改善皮肤健康',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: null
  }]
  
  let GoodCardList = {
    type: 'goodCard', 
    textWidth: '50%',
    title: '向损伤细胞精准、高效和持续的线粒体递送。',
    description: '从细胞器水平进行的精准干预，直接跨越细胞物理屏障，向受损组织注入全新“生命电池”。通过功能替代实现细胞能量稳态的重塑与氧化应激的深度抑制。这一疗法在攻克神经退行性疾病、心肌损伤及代谢障碍等医学顽疾中已展现出突破性前景，正以底层重构的方式，全面推离人类对抗衰老与重症的干预维度。',
    cardList: [],
    // cardList:[{
    //   type: 'img',
    //   content: {
    //     title: '对身体的益处',
    //     img: <img src={require('../../../image/sticky-img.webp')} style={{width: '100%',borderRadius:5}}/>,
    //     list: [
    //       {name: '搭载独家专利配方「科学配比NMN+」',icon: Energy1},
    //       {name: '生物利用度提升5-10倍',icon: Endurance},
    //       {name: '靶向补充NAD+',icon: Strength},
    //     ],
    //   },
    //   btnConfig: {
    //     icon: 'ArrowRightOutlined',
    //     link: '/science'
    //   }
    // },{
    //   type: 'img',
    //   content: {
    //     title: '前往科学',
    //     img: <img src={require('../../../image/bigCardBg2-1200x964.png')} style={{width: '100%',borderRadius:5}}/>,
    //     list: [
    //       {name: '改善肺部纤维化及炎症，提升呼吸效率',icon: Energy2},
    //       {name: '清新口气，减少口腔问题困扰',icon: Youthfulness},
    //       {name: '温和唤醒身体，替代传统提神方式',icon: Resilience},
    //     ],
    //   },
    //   btnConfig: {
    //     icon: 'ArrowRightOutlined',
    //     link: '/studies'
    //   }
    // }]
  }
  
  let expertList = [{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert1.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: '顾正龙',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '科学顾问',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: '国际知名遗传学家，复旦大学特聘教授，康奈尔大学客座教授。研究方向主要集中在线粒体与疾病、基因组功能与进化、多基因调控网络的功能和进化等诸多领域，在多种顶级国际学术期刊上发表科技前沿逾60余篇，包括Nature、Nature Genetics、PNAS、Genome Research、FASEB、MBE、JBC等，文章被引用总计超4700次。',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  }]
  
  let PhotoWallData = {
    drawer: true,
    title: '这一切都是由一组顶尖科学家实现的',
    titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
    subTitle: '',
    subTitleSize: '',
    subTitle2: '科学和临床顾问',
    description: '我们得到了一组有成就的科学和临床顾问的知识和指导，他们的专业知识涵盖微生物组科学、基因组学、代谢组学、胃肠病学、免疫学、营养学、皮肤病学和人类临床研究。',
    descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    data: expertList
  }
  
  let imgCardData_textLeft = {
    type: 'imgCard',
    bgImg: require('../../../image/bigCardBg1-1600x2000.png'),
    textWidth: '45%',
    textPosition: 'left',
    textAlignItem: 'top',
    title: '已证实的好处',
    titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
    spacing: 20,
    description: '我们的科学家不断进行彻底的临床研究，以证明线粒体对人体细胞的不可思议的影响，并揭示其全部潜力。',
    descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    descriptionColor: '#272724',
    childDom: [{
      type: 'icon',
      content: {
        top: <img style={{width: 40}} src={Energy_Black} alt="" />,
        divider: true,
        title: '能量',
        titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
        description: 'ATP产能提升，细胞活力增强',
        descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      },
      btnConfig: {
        icon: 'PlusOutlined',
        link: ''
      }
    },{
      type: 'icon',
      content: {
        top: <img style={{width: 40}} src={Strength_Black} alt="" />,
        divider: true,
        title: '细胞结构稳态',
        titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
        description: '更有序的细胞命运调控',
        descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      },
      btnConfig: {
        icon: 'PlusOutlined',
        link: ''
      }
    },{
      type: 'icon',
      content: {
        top: <img style={{width: 40}} src={Endurance_Black} alt="" />,
        divider: true,
        title: '氧化应激',
        titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
        description: '降低细胞损伤与症因子',
        descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      },
      btnConfig: {
        icon: 'PlusOutlined',
        link: ''
      }
    },{
      type: 'icon',
      content: {
        top: <img style={{width: 40}} src={OptimalLevels_Black} alt="" />,
        divider: true,
        title: '衰老环境',
        titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
        description: '清除衰老标志物SASP',
        descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      },
      btnConfig: {
        icon: 'PlusOutlined',
        link: ''
      }
    }],
    btnConfig:{
      text: 'Learn more',
      link: ''
    }
  }

  let dbCard = {
    type: 'dbCard',
    title: '皮肤老化是由两种因素引起的',
    description: '内在和外在因素会导致皮肤衰老的明显迹象，如皱纹、色素沉着、松弛和失去光泽。它们还会使皮肤变得更薄、更干燥，从而削弱其长期保持健康和年轻的能力。',
    list:[{
      img: require('../../../image/db-card-img-1.avif'),
      title: 'Foods (e.g Pomegranates)',
      childList: [{
        title: 'Uncertain',
        description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
        link: ''
      },{
        title: 'Uncertain',
        description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
        link: ''
      }]
    },{
      img: require('../../../image/db-card-img-2.avif'),
      title: 'Mitopure®',
      childList: [{
        title: 'Uncertain',
        description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
        link: ''
      },{
        title: 'Uncertain',
        description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
        link: ''
      }]
    }]
  }

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (location.state && location.state.scrollPosition === 0) {
      window.scrollTo(0, 0);
    }

    // 定义滚动事件处理函数
    const calculateBottomDistance = () => {
      if (stickyRef.current) {
        const rect = stickyRef.current.getBoundingClientRect();
        setDistanceToTop(rect.bottom);
        setWinH(window.innerHeight);
      }
    };
    // 添加滚动事件监听器
    window.addEventListener('scroll', calculateBottomDistance);
    setSelectMenu(menuData[0])




    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 


    // 在组件卸载时移除监听器
    return () => {
      window.removeEventListener('scroll', calculateBottomDistance);
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  return (
    <div className="Science-page">
      {/* <div style={{width: '100%', maxWidth: 1440, margin: '0 auto'}}>
        <BigCard bigCardData={imgCardData}/>
      </div> */}
      
      <div style={{width: 'calc(100% - 20px)', margin: '0 auto'}}>
        <BigCard bigCardData={bigCardData}/>
      </div>

      <div style={{width: 'calc(100% - 20px)', margin: '0 auto'}}>
        <HumanBody />
      </div>
      
      
      {/* 蒙面滑动 */}
      {width > 770? 
        <div className="sticky-box" style={{width: '100%'}}>
          <div className="sticky-img-box">
            <div className="sticky-img-content">
              <img className="sticky-img" src={require('../../../image/sticky-img.webp')} alt="" />
            </div>
            <div className="sticky-img-content" style={{clipPath: `inset(0 0 ${100-(distanceToTop/winH*100)}%)`}}>
              <img className="sticky-grey-img" src={require('../../../image/sticky-grey-img.webp')} alt="" />
            </div>
          </div>

          <div className="sticky-content-box">
            <div className="sticky-content-1" ref={stickyRef}>
              <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                <div className="sticky-content">
                  <div className="title">随着年龄的增长，线粒体功能下降</div>
                  <div className="description">我们的线粒体不断更新，以产生能量，满足肌肉、皮肤和其他组织的巨大能量需求。随着年龄的增长，线粒体的更新能力下降，功能失调的线粒体在细胞中积累，导致严重的问题。</div>
                  <Row gutter={[16,16]}>
                    {stickyIconList.map((e,i)=>{
                      return (
                        <Col span={24/stickyIconList.length} key={i}>
                          <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                        </Col>
                      )
                    })}
                  </Row>
                </div>
              </div>
              <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                <div className="sticky-content">
                    <div className="title">这种下降开始的时间比你想象的要早</div>
                    <div className="description">与年龄相关的线粒体衰退导致我们的代谢、整体能量水平、恢复力、皮肤健康和肌肉功能逐渐下降。</div>
                    
                    <Menu menuData={menuData} selectMenu={selectMenu} setSelectMenu={setSelectMenu}/>
                    <div className="legend-box">
                      <div className="legend-item">健康老龄化</div>
                      <div className="legend-item">平均年龄</div>
                    </div>
                    <ChartLineDom />
                </div>
              </div>
            </div>
            <div className="sticky-content-2">
              <div className="sticky-content">
                <div className="title">健康的细胞依赖于强大的回收过程</div>
                <div className="description">一种称为线粒体吞噬的过程可以清除有缺陷的线粒体，使线粒体能够自我修复并提高其性能。这种回收和清洁机制已被证明可以提供宝贵的健康益处。</div>
                <Row gutter={[16,16]}>
                  {stickyIconList2.map((e,i)=>{
                    return (
                      <Col span={24/stickyIconList2.length} key={i}>
                        <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                      </Col>
                    )
                  })}
                </Row>
              </div>
            </div>
          </div>
        </div>
        :
        <div className="sticky-box" style={{width: '100%', marginBottom: 25}}>
          <div style={{width: '100%', padding:'25px', borderTop: '0.5px solid #E5E5E2', borderBottom: '0.5px solid #E5E5E2'}}>
            <div className="title">随着年龄的增长，线粒体功能下降</div>
            <div className="description">我们的线粒体不断更新，以产生能量，满足肌肉、皮肤和其他组织的巨大能量需求。随着年龄的增长，线粒体的更新能力下降，功能失调的线粒体在细胞中积累，导致严重的问题。</div>
            <Row gutter={[30,24]}>
              {stickyIconList.map((e,i)=>{
                return (
                  <Col span={24/stickyIconList.length} key={i}>
                    <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  </Col>
                )
              })}
            </Row>
            <div className="sticky-img-content">
              <img className="sticky-grey-img" style={{width: '100%'}} src={require('../../../image/sticky-grey-img.webp')} alt="" />
            </div>
            <div className="title">这种下降开始的时间比你想象的要早</div>
            <div className="description">与年龄相关的线粒体衰退导致我们的代谢、整体能量水平、恢复力、皮肤健康和肌肉功能逐渐下降。</div>
            
            <Menu menuData={menuData} selectMenu={selectMenu} setSelectMenu={setSelectMenu}/>
            <div className="legend-box">
              <div className="legend-item">健康老龄化</div>
              <div className="legend-item">平均年龄</div>
            </div>
            <ChartLineDom />
          </div>

          <div style={{width: '100%', padding:'25px', borderBottom: '0.5px solid #E5E5E2'}}>
            <div className="title">健康的细胞依赖于强大的回收过程</div>
            <div className="sticky-img-content">
              <img className="sticky-img" style={{width: '100%'}} src={require('../../../image/sticky-img.webp')} alt="" />
            </div>
            <div className="description">一种称为线粒体吞噬的过程可以清除有缺陷的线粒体，使线粒体能够自我修复并提高其性能。这种回收和清洁机制已被证明可以提供宝贵的健康益处。</div>
            <Row gutter={[30,24]}>
              {stickyIconList.map((e,i)=>{
                return (
                  <Col span={12} key={i}>
                    <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  </Col>
                )
              })}
            </Row>
          </div>
        </div>
      }
      

      <div style={{width: 'calc(100% - 20px)', margin: '0 auto'}}>
        <BigCard bigCardData={bigCardData1}/>
      </div>

      <div style={{width: '100%', maxWidth: 1440, margin: '0 auto'}}>
        <BigCard bigCardData={GoodCardList}/>
      </div>
      
      {/* 专家照片墙 */}
      <PhotoWall PhotoWallData={PhotoWallData}/>

      
      <div style={{width: '100%', maxWidth: 1440, margin: '40px auto'}}>
        <BigCard bigCardData={imgCardData_textLeft}/>
      </div>

      {/* <div style={{width: '100%', maxWidth: 1440, margin: '40px auto'}}>
        <BigCard bigCardData={dbCard}/>
      </div> */}
    </div>
  );
};

export default Science;